import {Player} from './player';

export enum GameType {
  Family = 'family',
  Friends = 'friends',
  Partners = 'partners',
  Other = 'other'
}

export interface StellingScore {
  stellingID: number;
  stellingScore: string;
}

export interface Game {
  id?: string;
  type?: GameType;
  gameDate?: string;
  numberOfPlayers?: number;
  location?: string;
  activationCode?: string;
  numberOfRounds?: number;
  stellingScores?: StellingScore[];
  players: Player[];
}
